import { create } from 'zustand';
import { genericTableDefaultState, certificationProfileActiveTableDefaultState, certificationProfileExpiredTableDefaultState, certificationProfileInProgressTableDefaultState, certificationsIndexTableDefaultState, teamMembersTableDefaultState, certificationsByTeamActiveTableDefaultState, certificationsByTeamInProgressTableDefaultState, certificationsByTeamExpiredTableDefaultState, playlistsTableDefaultState } from './myTeamTableStateStoreConsts';
import { trimUrlState, getUrlState } from './myTeamTableStateStoreUtils';
const getTableStateSetter = set => stateValuesToSet => set(store => Object.assign({}, store, {
  state: Object.assign({}, store.state, stateValuesToSet)
}));
const getTableStateCreator = (tableName, tableSpecificDefaults) => set => {
  const defaultState = Object.assign({}, genericTableDefaultState, tableSpecificDefaults);
  const setState = getTableStateSetter(set);
  return {
    tableName,
    state: defaultState,
    defaultState,
    actions: {
      setSearch: search => setState({
        search,
        page: 1
      }),
      setTeams: teams => setState({
        teams,
        page: 1
      }),
      setUsers: users => setState({
        users,
        page: 1
      }),
      setAssignedByMe: assignedByMe => setState({
        assignedByMe,
        page: 1
      }),
      setCategories: categories => setState({
        categories,
        page: 1
      }),
      setTools: tools => setState({
        tools,
        page: 1
      }),
      setCertificationStatuses: certificationStatuses => setState({
        certificationStatuses,
        page: 1
      }),
      setPlaylists: playlists => setState({
        playlists,
        page: 1
      }),
      setDueDate: dueDate => setState({
        dueDate,
        page: 1
      }),
      setCompletedDate: completedDate => setState({
        completedDate,
        page: 1
      }),
      setPage: page => setState({
        page
      }),
      setPageSize: pageSize => setState({
        pageSize,
        page: 1
      }),
      setSortBy: sortBy => setState({
        sortBy,
        page: 1
      }),
      setSortOrder: sortOrder => setState({
        sortOrder,
        page: 1
      }),
      setIsUserPinned: isUserPinned => setState({
        isUserPinned
      }),
      initializeFromUrl: search => {
        const searchParams = new URLSearchParams(search || window.location.search);
        const params = Object.fromEntries(searchParams.entries());
        const urlState = getUrlState(params, defaultState, tableName);
        const trimmedUrlState = trimUrlState(urlState, tableName);
        setState(trimmedUrlState);
      },
      resetTableState: () => setState(defaultState)
    }
  };
};
export const useCertificationProfileActiveTableStore = create(getTableStateCreator('certificationProfileActive', certificationProfileActiveTableDefaultState));
export const useCertificationProfileExpiredTableStore = create(getTableStateCreator('certificationProfileExpired', certificationProfileExpiredTableDefaultState));
export const useCertificationProfileInProgressTableStore = create(getTableStateCreator('certificationProfileInProgress', certificationProfileInProgressTableDefaultState));
export const useCertificationsTableStore = create(getTableStateCreator('certificationsIndex', certificationsIndexTableDefaultState));
export const useTeamMembersTableStore = create(getTableStateCreator('teamMembers', teamMembersTableDefaultState));
export const useCertificationsByTeamActiveTableStore = create(getTableStateCreator('certificationsByTeamActive', certificationsByTeamActiveTableDefaultState));
export const useCertificationsByTeamInProgressTableStore = create(getTableStateCreator('certificationsByTeamInProgress', certificationsByTeamInProgressTableDefaultState));
export const useCertificationsByTeamExpiredTableStore = create(getTableStateCreator('certificationsByTeamExpired', certificationsByTeamExpiredTableDefaultState));

// Cache playlist table stores by table name so the same store instance is reused
const playlistTableStores = {};
export const usePlaylistsTableStore = tableName => {
  if (!playlistTableStores[tableName]) {
    playlistTableStores[tableName] = create(getTableStateCreator(tableName, playlistsTableDefaultState));
  }
  return playlistTableStores[tableName]();
};